import { useContext, useMemo } from 'react';
import _ from 'lodash';
import TableContext from '../TableContext';

const searchDefault = (cellValue, { queryRegEx }) => {
  // to search data with space.normal scenario
  if (queryRegEx.toString().indexOf(' ') >= 0) {
    return queryRegEx.test(cellValue);
  }
  // to search data with no space.remove space from cellValue and test

  if (cellValue !== null && cellValue !== undefined) {
    const cellValueWithoutSpace = cellValue.toString().replaceAll(' ', '');
    return queryRegEx.test(cellValueWithoutSpace);
  }
};

function getSearchMethod(column) {
  // 1. Specified in column config
  if (_.isFunction(column.search)) {
    return column.search;
  }

  // 2. Default search
  return searchDefault;
}

const SearchEvaluator = ({ data, children }) => {
  const { query, isQueryActive, columns } = useContext(TableContext);

  const dataMatchingQuery = useMemo(() => {
    if (!isQueryActive) {
      return data;
    }

    let queryModifiedData = query;
    if (query.endsWith('\\')) {
      queryModifiedData = query.replace(/\\/g, '\\\\');
    }

    queryModifiedData = queryModifiedData.replace(
      /[.*+?^${}()|[\]\\]/g,
      '\\$&'
    );
    const queryRegEx = new RegExp(queryModifiedData, 'i');

    function isRowMatching(rowData) {
      return columns.some(column => {
        if (!column.searchable) {
          return false;
        }
        const cellValue = rowData[column.name];
        const searchMethod = getSearchMethod(column);
        return searchMethod(cellValue, { queryRegEx, rowData });
      });
    }
    const matches = data.filter(isRowMatching);
    return matches;
  }, [query, isQueryActive, data, columns]);

  return children(dataMatchingQuery);
};

export default SearchEvaluator;
